import { render } from "./SmartSearch.vue?vue&type=template&id=f6e8b1b2&ts=true"
import script from "./SmartSearch.vue?vue&type=script&lang=ts"
export * from "./SmartSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__